"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _logoWithoutLink = _interopRequireDefault(require("../logo-without-link"));

// Logo
// ====
var Logo = function Logo(_ref) {
  var url = _ref.url,
      className = _ref.className,
      linkClassName = _ref.linkClassName,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type;

  if (url) {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: linkClassName,
      href: url
    }, /*#__PURE__*/_react.default.createElement(_logoWithoutLink.default, {
      className: className,
      type: type
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement(_logoWithoutLink.default, {
      className: className,
      type: type
    });
  }
};

Logo.propTypes = {
  url: _propTypes.default.string,
  className: _propTypes.default.string,
  linkClassName: _propTypes.default.string
};
var _default = Logo;
exports.default = _default;